import React from "react";
import { useTranslation } from "react-i18next";

import SelectChip from "../SelectChip/SelectChip";

const LanguageChip = (props) => {
  const { t, i18n } = useTranslation();

  const changeHandler = (e) => {
    i18n.changeLanguage(e.target.value.toLowerCase());
    props.onChange && props.onChange(e);
  };

  const languages = {
    EN: "English",
    SR: "Srpski",
  };

  return (
    <SelectChip
      onChange={changeHandler}
      svg={globus}
      values={languages}
      visibleValues={["English", "Srpski"]}
      preselect={i18n.language.toUpperCase()}
    />
  );
};

export default LanguageChip;

const globus = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48609 0 0 4.48609 0 10C0 15.5139 4.48609 20 10 20C15.5139 20 20 15.5139 20 10C20 4.48609 15.5139 0 10 0ZM10 18.3333C7.72984 18.3333 5.67109 17.4186 4.16668 15.9412V14.5833C4.16668 14.187 4.3441 13.9319 4.54918 13.6364C4.76035 13.3325 5 12.9879 5 12.5C5 11.7053 4.28262 11.6248 3.89688 11.5816C3.62098 11.5507 3.36059 11.5214 3.21125 11.3721C3.09812 11.2589 2.985 11.0535 2.86539 10.8362C2.62785 10.404 2.30586 9.83246 1.69285 9.48242C1.96234 5.12875 5.57957 1.66668 10 1.66668C10.2287 1.66668 10.4536 1.68285 10.6777 1.70102C10.6321 1.73098 10.5762 1.75133 10.5387 1.78875C10.4578 1.86973 10.4134 1.98082 10.4167 2.09555C10.4204 2.20988 10.4708 2.31813 10.5562 2.39461C10.706 2.52766 10.7349 2.5948 10.7406 2.5948C10.7312 2.61473 10.6547 2.74535 10.2283 2.96184C9.52434 3.31867 8.71137 4.04906 8.59051 4.80918C8.53516 5.15422 8.63527 5.47445 8.87207 5.71129C8.9502 5.78941 9.05598 5.83336 9.16668 5.83336C9.74531 5.83336 10.1925 5.61934 10.625 5.41262C11.0689 5.20059 11.4884 5 12.0833 5C13.7187 5 15 5.36621 15 5.83332C15 6.00461 14.9467 6.05711 14.9264 6.07664C14.7217 6.27805 14.0247 6.26504 13.4119 6.25566C13.2495 6.25281 13.0835 6.24996 12.9167 6.24996C12.3511 6.24996 12.1757 6.16734 11.9727 6.07133C11.7362 5.95984 11.4685 5.83328 10.8333 5.83328C10.1465 5.83328 8.87004 5.95738 8.03871 6.78867C7.35879 7.4682 7.43078 8.28117 7.47801 8.81871C7.48898 8.94242 7.5 9.05961 7.5 9.1666C7.5 9.9873 8.33863 10.4166 9.16668 10.4166C10.4403 10.4166 11.5414 10.6542 11.6667 10.8333C11.6667 11.2996 11.8054 11.6182 11.9169 11.8737C12.0097 12.0873 12.0833 12.2558 12.0833 12.4999C12.0833 12.6887 12.0524 12.729 11.969 12.8364C11.8099 13.0432 11.6666 13.2682 11.6666 13.7499C11.6666 14.6268 12.511 15.5887 12.607 15.6957C12.6871 15.7845 12.8003 15.8333 12.9166 15.8333C12.9512 15.8333 12.9858 15.8292 13.02 15.8203C13.2654 15.7572 15.4166 15.1652 15.4166 13.75C15.4166 13.3064 15.5546 13.1868 15.7637 13.0053C15.9688 12.8271 16.25 12.5834 16.25 12.0833C16.25 11.7492 16.8428 10.887 17.3921 10.2795C17.4699 10.1936 17.5085 10.0789 17.4984 9.96332C17.4882 9.84777 17.4304 9.74156 17.3389 9.67074C17.015 9.41969 16.1206 8.60223 15.8211 7.80918C15.9908 7.89789 16.2032 8.04234 16.3721 8.21121C16.5108 8.35078 16.6968 8.4175 16.9084 8.40898C17.2458 8.38973 17.6467 8.12309 18.0266 7.79051C18.221 8.49543 18.3334 9.2341 18.3334 10C18.3333 14.5951 14.5951 18.3333 10 18.3333Z"
      fill="#9CA3AF"
    ></path>
  </svg>
);
